/* tslint:disable */
/* eslint-disable */
/**
 * Pecosta Reporting API
 * Data pro reporty nad ClickHouse
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CheckReport
 */
export interface CheckReport {
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'service': string;
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'environment'?: string | null;
    /**
     * 
     * @type {CheckStatus}
     * @memberof CheckReport
     */
    'status': CheckStatus;
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'checkedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckReport
     */
    'cached'?: boolean;
    /**
     * 
     * @type {Array<CheckResult>}
     * @memberof CheckReport
     */
    'checks': Array<CheckResult>;
}


/**
 * 
 * @export
 * @interface CheckResult
 */
export interface CheckResult {
    /**
     * 
     * @type {string}
     * @memberof CheckResult
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CheckResult
     */
    'target'?: string | null;
    /**
     * 
     * @type {CheckStatus}
     * @memberof CheckResult
     */
    'status': CheckStatus;
    /**
     * 
     * @type {number}
     * @memberof CheckResult
     */
    'latencyMs'?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckResult
     */
    'detail'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CheckStatus = {
    Ok: 'OK',
    Fail: 'FAIL',
    Skipped: 'SKIPPED'
} as const;

export type CheckStatus = typeof CheckStatus[keyof typeof CheckStatus];


/**
 * 
 * @export
 * @interface IngestOrderItemRequest
 */
export interface IngestOrderItemRequest {
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'orderSentDate': string;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'orderSentAt': string;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'orderId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'orderItemId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'orderNumber': string;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'parentCompanyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'supplierId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'portalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'categoryEcid': string;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'productEcid': string;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'priceVariantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'priceType': string;
    /**
     * 
     * @type {boolean}
     * @memberof IngestOrderItemRequest
     */
    'isGaranted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'priceUnit': string;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'purchasePrice': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'auctionPrice': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'basicPrice': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'packageItemPrice': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'vatRate': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'lineNet': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'lineGross': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'minGuaranteedPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'minGuaranteedAuctionPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'minGuaranteedVariantId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'minGuaranteedSupplierId'?: number | null;
}
/**
 * 
 * @export
 * @interface IngestOrderItemsRequest
 */
export interface IngestOrderItemsRequest {
    /**
     * 
     * @type {Array<IngestOrderItemRequest>}
     * @memberof IngestOrderItemsRequest
     */
    'items': Array<IngestOrderItemRequest>;
}
/**
 * 
 * @export
 * @interface IngestOrderItemsResponse
 */
export interface IngestOrderItemsResponse {
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemsResponse
     */
    'insertedRows'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ReportCode = {
    EventsDailySummary: 'EVENTS_DAILY_SUMMARY',
    PurchasesByCategory: 'PURCHASES_BY_CATEGORY',
    OverpaidItems: 'OVERPAID_ITEMS',
    PurchasesByBuyer: 'PURCHASES_BY_BUYER',
    PurchaseSummary: 'PURCHASE_SUMMARY'
} as const;

export type ReportCode = typeof ReportCode[keyof typeof ReportCode];


/**
 * 
 * @export
 * @interface ReportColumnResponse
 */
export interface ReportColumnResponse {
    /**
     * 
     * @type {string}
     * @memberof ReportColumnResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ReportColumnResponse
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ReportDefinitionResponse
 */
export interface ReportDefinitionResponse {
    /**
     * 
     * @type {ReportCode}
     * @memberof ReportDefinitionResponse
     */
    'code': ReportCode;
    /**
     * 
     * @type {string}
     * @memberof ReportDefinitionResponse
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ReportDefinitionResponse
     */
    'description': string;
    /**
     * 
     * @type {Array<ReportParamResponse>}
     * @memberof ReportDefinitionResponse
     */
    'params': Array<ReportParamResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof ReportDefinitionResponse
     */
    'supportsGroupBy'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ReportGroupBy = {
    Company: 'COMPANY',
    User: 'USER'
} as const;

export type ReportGroupBy = typeof ReportGroupBy[keyof typeof ReportGroupBy];


/**
 * 
 * @export
 * @interface ReportParamResponse
 */
export interface ReportParamResponse {
    /**
     * 
     * @type {string}
     * @memberof ReportParamResponse
     */
    'name': string;
    /**
     * 
     * @type {ReportParamType}
     * @memberof ReportParamResponse
     */
    'type': ReportParamType;
    /**
     * 
     * @type {boolean}
     * @memberof ReportParamResponse
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportParamResponse
     */
    'description': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ReportParamType = {
    String: 'STRING',
    Long: 'LONG',
    Decimal: 'DECIMAL',
    Boolean: 'BOOLEAN',
    Date: 'DATE',
    DateTime: 'DATE_TIME'
} as const;

export type ReportParamType = typeof ReportParamType[keyof typeof ReportParamType];


/**
 * 
 * @export
 * @interface ReportRunRequest
 */
export interface ReportRunRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ReportRunRequest
     */
    'params': { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof ReportRunRequest
     */
    'maxRows'?: number | null;
    /**
     * 
     * @type {ReportGroupBy}
     * @memberof ReportRunRequest
     */
    'groupBy'?: ReportGroupBy | null;
}


/**
 * 
 * @export
 * @interface ReportRunResponse
 */
export interface ReportRunResponse {
    /**
     * 
     * @type {ReportCode}
     * @memberof ReportRunResponse
     */
    'code': ReportCode;
    /**
     * 
     * @type {Array<ReportColumnResponse>}
     * @memberof ReportRunResponse
     */
    'columns': Array<ReportColumnResponse>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof ReportRunResponse
     */
    'rows': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {number}
     * @memberof ReportRunResponse
     */
    'rowCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportRunResponse
     */
    'truncated'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReportRunResponse
     */
    'durationMs'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportRunResponse
     */
    'generatedAt': string;
}



/**
 * CheckResourceApi - axios parameter creator
 * @export
 */
export const CheckResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check
         * @param {string | null} [only] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkGet: async (only?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (only !== undefined) {
                localVarQueryParameter['only'] = only;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CheckResourceApi - functional programming interface
 * @export
 */
export const CheckResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CheckResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check
         * @param {string | null} [only] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkGet(only?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkGet(only, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CheckResourceApi.checkGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CheckResourceApi - factory interface
 * @export
 */
export const CheckResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CheckResourceApiFp(configuration)
    return {
        /**
         * 
         * @summary Check
         * @param {CheckResourceApiCheckGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkGet(requestParameters: CheckResourceApiCheckGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CheckReport> {
            return localVarFp.checkGet(requestParameters.only, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CheckResourceApi - interface
 * @export
 * @interface CheckResourceApi
 */
export interface CheckResourceApiInterface {
    /**
     * 
     * @summary Check
     * @param {CheckResourceApiCheckGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckResourceApiInterface
     */
    checkGet(requestParameters?: CheckResourceApiCheckGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckReport>;

}

/**
 * Request parameters for checkGet operation in CheckResourceApi.
 * @export
 * @interface CheckResourceApiCheckGetRequest
 */
export interface CheckResourceApiCheckGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CheckResourceApiCheckGet
     */
    readonly only?: string | null
}

/**
 * CheckResourceApi - object-oriented interface
 * @export
 * @class CheckResourceApi
 * @extends {BaseAPI}
 */
export class CheckResourceApi extends BaseAPI implements CheckResourceApiInterface {
    /**
     * 
     * @summary Check
     * @param {CheckResourceApiCheckGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckResourceApi
     */
    public checkGet(requestParameters: CheckResourceApiCheckGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CheckResourceApiFp(this.configuration).checkGet(requestParameters.only, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InfoResourceApi - axios parameter creator
 * @export
 */
export const InfoResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Build Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InfoResourceApi - functional programming interface
 * @export
 */
export const InfoResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InfoResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Build Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async infoGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.infoGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InfoResourceApi.infoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InfoResourceApi - factory interface
 * @export
 */
export const InfoResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InfoResourceApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Build Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoGet(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.infoGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InfoResourceApi - interface
 * @export
 * @interface InfoResourceApi
 */
export interface InfoResourceApiInterface {
    /**
     * 
     * @summary Get Build Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoResourceApiInterface
     */
    infoGet(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

}

/**
 * InfoResourceApi - object-oriented interface
 * @export
 * @class InfoResourceApi
 * @extends {BaseAPI}
 */
export class InfoResourceApi extends BaseAPI implements InfoResourceApiInterface {
    /**
     * 
     * @summary Get Build Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoResourceApi
     */
    public infoGet(options?: RawAxiosRequestConfig) {
        return InfoResourceApiFp(this.configuration).infoGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IngestApi - axios parameter creator
 * @export
 */
export const IngestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Zapise davku polozek odeslane objednavky do order_items_fact
         * @param {IngestOrderItemsRequest} ingestOrderItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIngestOrderItemsPost: async (ingestOrderItemsRequest: IngestOrderItemsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ingestOrderItemsRequest' is not null or undefined
            assertParamExists('apiIngestOrderItemsPost', 'ingestOrderItemsRequest', ingestOrderItemsRequest)
            const localVarPath = `/api/ingest/order-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestOrderItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Overi ingest token volajiciho (204 = zapis povolen)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIngestPingGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ingest/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IngestApi - functional programming interface
 * @export
 */
export const IngestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IngestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Zapise davku polozek odeslane objednavky do order_items_fact
         * @param {IngestOrderItemsRequest} ingestOrderItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIngestOrderItemsPost(ingestOrderItemsRequest: IngestOrderItemsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestOrderItemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIngestOrderItemsPost(ingestOrderItemsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IngestApi.apiIngestOrderItemsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Overi ingest token volajiciho (204 = zapis povolen)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIngestPingGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIngestPingGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IngestApi.apiIngestPingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IngestApi - factory interface
 * @export
 */
export const IngestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IngestApiFp(configuration)
    return {
        /**
         * 
         * @summary Zapise davku polozek odeslane objednavky do order_items_fact
         * @param {IngestApiApiIngestOrderItemsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIngestOrderItemsPost(requestParameters: IngestApiApiIngestOrderItemsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<IngestOrderItemsResponse> {
            return localVarFp.apiIngestOrderItemsPost(requestParameters.ingestOrderItemsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Overi ingest token volajiciho (204 = zapis povolen)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIngestPingGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiIngestPingGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IngestApi - interface
 * @export
 * @interface IngestApi
 */
export interface IngestApiInterface {
    /**
     * 
     * @summary Zapise davku polozek odeslane objednavky do order_items_fact
     * @param {IngestApiApiIngestOrderItemsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestApiInterface
     */
    apiIngestOrderItemsPost(requestParameters: IngestApiApiIngestOrderItemsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<IngestOrderItemsResponse>;

    /**
     * 
     * @summary Overi ingest token volajiciho (204 = zapis povolen)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestApiInterface
     */
    apiIngestPingGet(options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for apiIngestOrderItemsPost operation in IngestApi.
 * @export
 * @interface IngestApiApiIngestOrderItemsPostRequest
 */
export interface IngestApiApiIngestOrderItemsPostRequest {
    /**
     * 
     * @type {IngestOrderItemsRequest}
     * @memberof IngestApiApiIngestOrderItemsPost
     */
    readonly ingestOrderItemsRequest: IngestOrderItemsRequest
}

/**
 * IngestApi - object-oriented interface
 * @export
 * @class IngestApi
 * @extends {BaseAPI}
 */
export class IngestApi extends BaseAPI implements IngestApiInterface {
    /**
     * 
     * @summary Zapise davku polozek odeslane objednavky do order_items_fact
     * @param {IngestApiApiIngestOrderItemsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestApi
     */
    public apiIngestOrderItemsPost(requestParameters: IngestApiApiIngestOrderItemsPostRequest, options?: RawAxiosRequestConfig) {
        return IngestApiFp(this.configuration).apiIngestOrderItemsPost(requestParameters.ingestOrderItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Overi ingest token volajiciho (204 = zapis povolen)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestApi
     */
    public apiIngestPingGet(options?: RawAxiosRequestConfig) {
        return IngestApiFp(this.configuration).apiIngestPingGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Detail definice jednoho reportu
         * @param {ReportCode} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportsCodeGet: async (code: ReportCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('apiReportsCodeGet', 'code', code)
            const localVarPath = `/api/reports/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Spusti report a vrati data
         * @param {ReportCode} code 
         * @param {ReportRunRequest} reportRunRequest 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportsCodeRunPost: async (code: ReportCode, reportRunRequest: ReportRunRequest, organizationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('apiReportsCodeRunPost', 'code', code)
            // verify required parameter 'reportRunRequest' is not null or undefined
            assertParamExists('apiReportsCodeRunPost', 'reportRunRequest', reportRunRequest)
            const localVarPath = `/api/reports/{code}/run`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportRunRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seznam dostupnych reportu vcetne jejich parametru
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Detail definice jednoho reportu
         * @param {ReportCode} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportsCodeGet(code: ReportCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportDefinitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportsCodeGet(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.apiReportsCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Spusti report a vrati data
         * @param {ReportCode} code 
         * @param {ReportRunRequest} reportRunRequest 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportsCodeRunPost(code: ReportCode, reportRunRequest: ReportRunRequest, organizationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportsCodeRunPost(code, reportRunRequest, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.apiReportsCodeRunPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Seznam dostupnych reportu vcetne jejich parametru
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportDefinitionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.apiReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Detail definice jednoho reportu
         * @param {ReportsApiApiReportsCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportsCodeGet(requestParameters: ReportsApiApiReportsCodeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReportDefinitionResponse> {
            return localVarFp.apiReportsCodeGet(requestParameters.code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Spusti report a vrati data
         * @param {ReportsApiApiReportsCodeRunPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportsCodeRunPost(requestParameters: ReportsApiApiReportsCodeRunPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReportRunResponse> {
            return localVarFp.apiReportsCodeRunPost(requestParameters.code, requestParameters.reportRunRequest, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seznam dostupnych reportu vcetne jejich parametru
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ReportDefinitionResponse>> {
            return localVarFp.apiReportsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportsApi - interface
 * @export
 * @interface ReportsApi
 */
export interface ReportsApiInterface {
    /**
     * 
     * @summary Detail definice jednoho reportu
     * @param {ReportsApiApiReportsCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApiInterface
     */
    apiReportsCodeGet(requestParameters: ReportsApiApiReportsCodeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReportDefinitionResponse>;

    /**
     * 
     * @summary Spusti report a vrati data
     * @param {ReportsApiApiReportsCodeRunPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApiInterface
     */
    apiReportsCodeRunPost(requestParameters: ReportsApiApiReportsCodeRunPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReportRunResponse>;

    /**
     * 
     * @summary Seznam dostupnych reportu vcetne jejich parametru
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApiInterface
     */
    apiReportsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ReportDefinitionResponse>>;

}

/**
 * Request parameters for apiReportsCodeGet operation in ReportsApi.
 * @export
 * @interface ReportsApiApiReportsCodeGetRequest
 */
export interface ReportsApiApiReportsCodeGetRequest {
    /**
     * 
     * @type {ReportCode}
     * @memberof ReportsApiApiReportsCodeGet
     */
    readonly code: ReportCode
}

/**
 * Request parameters for apiReportsCodeRunPost operation in ReportsApi.
 * @export
 * @interface ReportsApiApiReportsCodeRunPostRequest
 */
export interface ReportsApiApiReportsCodeRunPostRequest {
    /**
     * 
     * @type {ReportCode}
     * @memberof ReportsApiApiReportsCodeRunPost
     */
    readonly code: ReportCode

    /**
     * 
     * @type {ReportRunRequest}
     * @memberof ReportsApiApiReportsCodeRunPost
     */
    readonly reportRunRequest: ReportRunRequest

    /**
     * 
     * @type {number}
     * @memberof ReportsApiApiReportsCodeRunPost
     */
    readonly organizationId?: number
}

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI implements ReportsApiInterface {
    /**
     * 
     * @summary Detail definice jednoho reportu
     * @param {ReportsApiApiReportsCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public apiReportsCodeGet(requestParameters: ReportsApiApiReportsCodeGetRequest, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).apiReportsCodeGet(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Spusti report a vrati data
     * @param {ReportsApiApiReportsCodeRunPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public apiReportsCodeRunPost(requestParameters: ReportsApiApiReportsCodeRunPostRequest, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).apiReportsCodeRunPost(requestParameters.code, requestParameters.reportRunRequest, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seznam dostupnych reportu vcetne jejich parametru
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public apiReportsGet(options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).apiReportsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



